// extracted by css-extract-rspack-plugin
export default {"header":"header-Eno7nv","title":"title-Y0Y8dO","inline":"inline-JxQg5p","infoLink":"infoLink-tPJoNo"};